import { Alert } from "@mui/material";
import { useState } from "react";

//level: error, warning, info, success
const AlertMessage = ({
  message,
  level = "error",
  closeEvt = true,
  mt = 0.8,
  mb = 0.8,
  ml = 0,
  mr = 0,
  isHtml = false,
}) => {
  const marginStyle = {
    marginTop: mt + "rem",
    marginBottom: mb + "rem",
    marginLeft: ml + "rem",
    marginRight: mr + "rem",
  };
  const [open, setOpen] = useState(true);
  const messageContent = isHtml && typeof message === "string"
    ? <span dangerouslySetInnerHTML={{ __html: message }}></span>
    : message;
  return (
    <>
      {closeEvt === true
        ? open &&
          typeof message === "string" && message && (
            <div style={marginStyle}>
              <Alert
                severity={level}
                onClose={() => setOpen(false)}
                className="msg-scroll-screen-y"
              >
                {messageContent}
              </Alert>
            </div>
          )
        : typeof message === "string" && message && (
            <div style={marginStyle}>
              <Alert severity={level} className="msg-scroll-screen-y">
                {messageContent}
              </Alert>
            </div>
          )}
    </>
  );
};

export default AlertMessage;
